import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=2efac241&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efac241')) {
      api.createRecord('2efac241', component.options)
    } else {
      api.reload('2efac241', component.options)
    }
    module.hot.accept("./aboutUs.vue?vue&type=template&id=2efac241&", function () {
      api.rerender('2efac241', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/help/aboutUs.vue"
export default component.exports